import { html, nothing } from 'lit-html';
import { repeat } from 'lit-html/directives/repeat';
import { ProductApi } from "../../../api/archive/product/product-api.js"
import { IVariantShortInfoResponse } from '../../../api/archive/product/interfaces/i-variant-short-info-response.js';
import { TilesVariantSelectorBase } from "./tiles-variant-selector-base.js";
import { IVariant } from './variant-selector-base.js';
import { IVariantShortInfo } from '../../../api/archive/product/interfaces/i-variant-short-info.js';
import { createElementFromHTML } from '../../../utils/dom_tools.js';

export class TilesVariantSelectorV2 extends TilesVariantSelectorBase {
    private _productApi: ProductApi = new ProductApi();
    private _variantsShortInfo: IVariantShortInfoResponse;
    private _regularSelectorDivElement: HTMLDivElement;

    protected template = () => html`
        <div class="c-tilesvariant2-term-definition">
            <label>${this.variantSelectorData.variantTypeName}:</label> <span class="js-selected-variant-name"></span>
        </div>
        <div class="c-tilesvariant2-list ts-regular-selector">
        ${repeat(this.variantSelectorData.variants, (variant: IVariant) => html`
            <button type="button" class="c-tilesvariant2-option js-variant" data-variantid="${variant.id}">
                <span class="c-tilesvariant2-name">${variant.name}</span>
                <div class="c-tilesvariant2-unavailable-text js-unavailable-text-container" style="display:none;">
                    <span class="c-tilesvariant2-unavailable-text-label js-unavailable-text"></span>
                </div>
            </button>
        `)}
        </div>
    `;

    protected getDataBeforeRender() {
        return {
            variantTypeName: this.variantType.name,
            variants: this.sortVariants(this.selectorContainerElement, this.variantType.variants, this.product),
        };
    }

    protected processAfterRender(): void {
        super.processAfterRender();
        const self = this;

        this._regularSelectorDivElement = this.selectorContainerElement.querySelector('.ts-regular-selector') as HTMLDivElement;
        this._regularSelectorDivElement.style.display = 'none';

        if(this.loadAdditionalInfo){
            this._productApi.getVariantsShortInfo(this.product.productId).then((variantsShortInfo) => {
                self._variantsShortInfo = variantsShortInfo;
                self._processOutletVariants();
            });
        } else {
            self._processOutletVariants();
        }
    }

    private _processOutletVariants() {
        this._regularSelectorDivElement.style.removeProperty('display');

        this._regularSelectorDivElement.querySelectorAll('button').forEach((variantButton: HTMLButtonElement) => {
            const variantId = parseInt(variantButton.getAttribute('data-variantid'));
            const variantShortInfo = this._variantsShortInfo?.variantShortInfoList.find(variantShortInfo => variantShortInfo.variantValues.includes(variantId));
            if(variantShortInfo && variantShortInfo.discountPercent > 0){
                const percentSpan = createElementFromHTML('<span class="c-tilesvariant2-discount">%</span>');
                variantButton.appendChild(percentSpan);
            }
        });
    }
}
